<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
library.add(faArrowUpRightFromSquare)
</script>
<template>
  <FontAwesomeIcon icon="fa-solid fa-arrow-up-right-from-square" />
</template>
